import React, { ComponentProps } from 'react';
import { asWidgetProps } from 'Src/types/widget-helpers';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { TravelDetail } from 'Components/widgets/travel-details/travel-detail/TravelDetail';
type Props = {
  adultsCounter: number;
  childrenCounter: number;
  className?: string;
};
const getAdultsLabel = (number) =>
  t(number > 1 ? 'common.participants.adults._n' : 'common.participants.adults._1', {
    count: number,
  });
const getChildrenProps = (number) =>
  number
    ? {
        text2: t('common.and'),
        highlightText2: t(
          number > 1 ? 'common.participants.children._n' : 'common.participants.children._1',
          {
            count: number,
          },
        ),
      }
    : null;
export const ParticipantsTravelDetails = ({ adultsCounter, childrenCounter, className }: Props) =>
  adultsCounter ? (
    <TravelDetail
      {...asWidgetProps<ComponentProps<typeof TravelDetail>>({
        className: className,
        icon: ICONS.PEOPLE_DOUBLE,
        infos: {
          text1: t('common.participants.for', {
            a: '',
          }).trim(),
          highlightText1: getAdultsLabel(adultsCounter),
          ...getChildrenProps(childrenCounter),
        },
      })}
    />
  ) : null;
